"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var SwitchLabel_1 = __importDefault(require("./common/SwitchLabel"));
var FormComponentUtils_1 = require("./common/FormComponentUtils");
var FieldValidationState_1 = require("./common/FieldValidationState");
var ValidationMessage_1 = __importDefault(require("./common/ValidationMessage"));
var Radio = function (props) {
    var additionalInfo = props.additionalInfo, checked = props.checked, disabled = props.disabled, formControlProps = props.formControlProps, invalid = props.invalid, label = props.label, large = props.large, name = props.name, onChange = props.onChange, value = props.value, validationMessage = props.validationMessage, validationState = props.validationState;
    var restrictedProps = [
        'checked', 'className', 'disabled', 'name', 'onChange', 'type', 'value'
    ];
    var attributes = FormComponentUtils_1.getFormControlAttributes(formControlProps, restrictedProps);
    return (react_1.default.createElement("label", { className: getClassNames(props) },
        react_1.default.createElement("input", __assign({}, attributes, { checked: checked, className: "fds-switch-input", disabled: disabled, name: name, onChange: onChange, type: "radio", value: value })),
        react_1.default.createElement("span", { className: "fds-switch-control", "aria-hidden": "true" }),
        react_1.default.createElement(SwitchLabel_1.default, { additionalInfo: additionalInfo, label: label, large: large },
            react_1.default.createElement(ValidationMessage_1.default, { validationMessage: validationMessage, validationState: invalid ? FieldValidationState_1.FieldValidationState.INVALID : validationState }))));
};
var getClassNames = function (props) {
    var classes = props.classes, disabled = props.disabled, fullWidth = props.fullWidth, invalid = props.invalid, reverse = props.reverse, validationState = props.validationState;
    return classnames_1.default('fds-switch', 'fds-switch-radio', {
        'is-disabled': disabled,
        'fds-switch-reverse': reverse,
        'fds-form-control-full-width': fullWidth,
        invalid: invalid || validationState === FieldValidationState_1.FieldValidationState.INVALID,
        valid: validationState === FieldValidationState_1.FieldValidationState.VALID
    }, classes);
};
exports.default = Radio;
